import { createFileRoute } from "@tanstack/react-router";
import { JoinCodePage } from "@/pages/auth/JoinCodePage";

export const Route = createFileRoute("/_onboarding/join/email")({ component: JoinCodePage });
